import { useStore } from "@/lib/store";

export function Toast() {
  const toast = useStore((state) => state.toast);

  if (!toast) return null;

  const colorClass =
    toast.type === "success"
      ? "bg-cyber-green/10 border-cyber-green/30 text-cyber-green"
      : "bg-cyber-red/10 border-cyber-red/30 text-cyber-red";

  return (
    <div className={`fixed right-4 bottom-4 rounded border px-4 py-2 ${colorClass} z-50 text-sm`}>
      {toast.message}
    </div>
  );
}
